<template>
    <div name="snackbars">
        <v-snackbar v-model="show" :color="color" :timeout="timeout">
            {{ message }}
            <template v-if="button" v-slot:action="{ attrs }">
                <v-btn :color="button.color" text v-bind="attrs" @click="button.callback">
                    {{ button.text }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { useGlobalState } from '@/stores/globalState';

export default {
    setup() {
        return {
            globalState: useGlobalState(),
        }
    },
    created() {
        this.globalState.$onAction(({ name, args }) => {
            if (name === 'showSnackbar') {
                const sbData = args[0];
                this.$nextTick(() => {
                    this.show = true;
                    this.message = (sbData || this.globalState?.snackbar)?.message;
                    this.color = (sbData || this.globalState?.snackbar)?.color;
                    this.timeout = (sbData || this.globalState?.snackbar)?.timeout;
                    this.button = (sbData || this.globalState?.snackbar)?.button;
                })
            }
        }, true);
        
    },
    data() {
        return {
            show: false,
            color: '',
            message: '',
            timeout: -1,
            button: null,
        };
    },
};
</script>
